var render = function render(){var _vm=this,_c=_vm._self._c;return _c('processed-image',{staticClass:"avatar",attrs:{"src":_vm.avatarSrc,"transforms":_vm.transforms,"width":_vm.width,"height":_vm.height,"alt":_vm.avatarAltTag,"aria-label":_vm.avatarAltTag},on:{"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }